import React from 'react';
import styled from 'styled-components';
import config from 'config';

const VersionWrapper = styled.div`
  text-align: right;
  color: ${p => p.theme.color.label};
  position: fixed;
  left: 0;
  bottom: 0;
  right: auto;
  padding: 0 0.5em;
  box-sizing: border-box;
  pointer-events: none;
  width: 100%;
  font-size: 0.8em;
`;

export default () => <VersionWrapper>version: {config.appVersion}</VersionWrapper>;
